
import {_, DataOptionItem, type PageContext} from '@zto/zpage'

import {
  commonOptions,
  DialogType,
  YesNo
} from '@/config'

function sortResponseOptionsTransformFn(prop?: string | null, transformType?: string) {
  const typeParts = transformType ? transformType.split(':') : ['code', 'name']

  return (data: any): DataOptionItem[] => {
    const items = prop ? data[prop] : Array.isArray(data) ? data : data?.data

    return (items || []).map((v: any) => {
      return { [typeParts[0]]: v, [typeParts[1]]: String(v) }
    })
  }
}

/**
 * 新增编辑对话框
 * @returns
 */
export function addEditDialog(dialogType: DialogType = DialogType.ADD) {
  const isAdd = dialogType === DialogType.ADD
  const isEdit = dialogType === DialogType.EDIT
  const isView = dialogType === DialogType.VIEW

  return {
    width: 800,
    labelWidth: 110,
    itemSpan: 24,

    // debug: true,

    formAttrs: {
      disabled: isView
    },

    formItemsAttrs: {
      itemWidth: '280px'
    },

    onShow: async ({ data }: PageContext) => {
      let payload = { ...data }

      payload.bindCatSpuList = payload.spuInfoVOList

      return { payload }
    },
    //
    beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
      // const payload = processJumpDataForSubmit({ ...model.value })
      //
      // delete payload._isApi
      // delete payload._oldData

      const payload = {
        ...data
      }

      return payload
    },

    formItems: [

      { label: '分类名称', type: 'input', prop: 'catName',  required: true },
      {
        label: '分类下商品',
        type: 'fuzzy-select',
        filterable: false,
        triggerFocus: true,
        multiple: true,
        prop: 'bindCatSpuList',
        labelProp: 'spuName',
        keywordProp: 'spuCode',
        api: 'admin/catInfo/queryGroundingSpuInfoWithoutCat',
        optionValueProp: 'spuCode',
        optionLabelProp: 'spuName',
        tpl: '${spuName}',
        apiParams: {
          pageSize:100,
          pageIndex:1,
        },
        dynamicAttrs: ({ data }: PageContext) => {
          const isVisible = true
          return { hidden: !isVisible, required: isVisible }
        }
      },
      {
        label: '上架后状态',
        type: 'checkbox',
        checkType: 'radio',
        prop: 'catStatus',
        options: [
          { label: '立即显示', value: 'grounding' },
          { label: '隐藏', value: 'off_shelf' }
        ],
        required: true,
        dynamicAttrs: ({ data }: PageContext) => {
          const isVisible = true
          return { hidden: !isVisible, required: isVisible }
        }
      },
    ],
  }
}
